import React from 'react'
import './CookieSettingsLink.scss'

/**
 * To work correctly with the OneTrust SDK, the following elements need tpo be present on the page:
 *   <a class="ot-sdk-show-settings" id="CookieSettingsLink-anchor" style="display: none;">Cookie settings</a>
 *   <div id="otCookiePolicy"></div>
 *   <div id="otPrivacyPolicy"></div>
 */
export const CookieSettingsLink = () => (
  <div className="CookieSettingsLink">
    <span
      className="proxyLink"
      role="link"
      onClick={() => {
        const el = document.getElementById('CookieSettingsLink-anchor')

        if (el instanceof HTMLAnchorElement) {
          el.click()
        }
      }}
    >
      Cookie settings
    </span>
  </div>
)